
import moment from 'moment'
import Vue from 'vue'
import { SetResponsePropsByIds } from '@/entities/Response'
import GetUnreadUseCase from '@/usecases/notification/GetUnreadUseCase'
import GetTalkUseCase from '@/usecases/talk/GetTalkUseCase'
import GetRoomUseCase from '@/usecases/room/GetRoomUseCase'
import FetchScheduleUseCase from '@/usecases/schedule/FetchScheduleUseCase'
import { EmptyQueryPropsFactory } from '@/entities/Query'

const component = Vue.extend({
  fetch() {
    this.fetch()
  },
  mounted() {
    this.talk()
    this.appointment()
    this.schedule()
    this.count()
  },
  beforeDestroy() {
    this.$echo.leave('room.talk')
    this.$echo.leave(`appointment.read.${this.App.doctor.current?.id}`)
    this.$echo.leave(`appointment.send.${this.App.doctor.current?.id}`)
  },
  methods: {
    fetch() {
      setTimeout(async () => {
        this.App.notification.unread = await new GetUnreadUseCase(this.App).execute()
      }, 1000)
    },
    count() {
      setTimeout(async () => {
        const started = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        const ended = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        const value = await new FetchScheduleUseCase(this.App).execute(
          EmptyQueryPropsFactory({ query: ['between', 'started_at', started, ended] })
        )
        this.App.schedule.count = value?.query.total ?? 0
      }, 1000)
    },
    talk() {
      this.$echo.channel('room.talk').listen('Room.Talk', async (e: any) => {
        if (this.$route.params.id === e.room_id) {
          this.App.talk.data = SetResponsePropsByIds(
            this.App.talk.data,
            await new GetTalkUseCase(this.App).execute(this.$route.params.id, e.talk_id)
          )
        } else if (e.talker_id === this.App.doctor.current?.id) {
          this.App.room.data = SetResponsePropsByIds(
            this.App.room.data,
            await new GetRoomUseCase(this.App).execute(e.room_id)
          )
          this.fetch()
        }
      })
    },
    appointment() {
      this.$echo.channel(`appointment.read.${this.App.doctor.current?.id}`).listen('Appointment.Read', () => {
        this.fetch()
      })
      this.$echo.channel(`appointment.send.${this.App.doctor.current?.id}`).listen('Appointment.Send', () => {
        this.fetch()
      })
    },
    schedule() {
      this.$echo.channel(`schedule.count.${this.App.hospital.current?.id}`).listen('Schedule.Count', () => {
        this.count()
      })
    }
  }
})

Vue.component('MAppNotification', component)
export default component
